import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { ManageProjectComponent, ManageProposalComponent, ManageProposalPeComponent }   from './manage-project.component';

import { ProjectDataComponent, ProposalDataComponent } from './project-data/project-data.component';
import { TaskListComponent } from './task-list/task-list.component';
import { ControlTecnicComponent } from './control-tecnic/control-tecnic.component';
import { CollaboratorsListComponent } from './collaborators-list/collaborators-list.component';
import { ClientsSocisListComponent } from './clients-socis-list/clients-socis-list.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { DocumentsComponent } from './documents-list/documents.component';

import { AngularMaterialModule } from '../angular-material.module';

import { FilterClientSocisPipe } from '../pipes/filtreclientsoci';

import { QuillModule } from 'ngx-quill';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({ 
  imports:      [
    CommonModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    TranslateModule,
    QuillModule.forRoot({
      modules: {
        syntax: false,
        toolbar: [['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'bullet' }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }],
        [ 'link' ],
        ['clean' ]   
      ]       // toggled buttons
     }
    })
  ],
  declarations: [
    ManageProjectComponent,
    ManageProposalComponent,
    ManageProposalPeComponent,
    ProjectDataComponent,
    ProposalDataComponent,
    TaskListComponent,
    CollaboratorsListComponent,
    ControlTecnicComponent,
    ContactListComponent,
    DocumentsComponent,
    ClientsSocisListComponent,
    FilterClientSocisPipe
  ],
  exports:      [ ManageProjectComponent, ManageProposalComponent, ManageProposalPeComponent ],
  providers:    [ 
    {provide: MatDialogRef, useValue: {}},
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ]
})

export class ManageProjectModule { }
